import module from './vuex'

const registerStore = store => {
  store.registerModule('tcLoader', { ...module })
}

export default registerStore



// WEBPACK FOOTER //
// ./src/plugins/loader/registerStore.js